// GenericNavigationMenu.tsx
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { ChevronRight, Info, LucideIcon } from "lucide-react-native";
// import { getResponsiveSize } from "../../components/shared/styles/globalStyles";
// import { FlickOColors } from "../shared/styles/color";
// import { config } from "../../config";
import { getResponsiveSize } from "../styles/globalStyles";
import { FlickOColors } from "../styles/color";
import { config } from "../../../config";

// Types for the menu configuration
export type MenuItem = {
  icon: LucideIcon;
  title: string;
  onPress: () => void;
  isDestructive?: boolean;
};

export type MenuSection = {
  items: MenuItem[];
};

export type NavigationMenuProps = {
  // Header configuration
  headerTitle?: string;
  showHeader?: boolean;
  CustomHeader?: React.ReactNode;

  // Profile section configuration
  profileName?: string;
  profileSubtext?: string;

  // Menu configuration
  menuSections: MenuSection[];
};

const GenericNavigationMenu: React.FC<NavigationMenuProps> = ({
  headerTitle = "Settings",
  showHeader = true,
  CustomHeader,
  profileName,
  profileSubtext,
  menuSections,
}) => {
  return (
    <View style={styles.container}>
      {CustomHeader}

      {(profileName || profileSubtext) && (
        <View style={styles.restaurantSection}>
          {profileName && (
            <Text style={styles.restaurantName}>{profileName}</Text>
          )}
          {profileSubtext && (
            <Text style={styles.emailText}>{profileSubtext}</Text>
          )}
        </View>
      )}

      {menuSections.map((section, sectionIndex) => (
        <View key={sectionIndex} style={styles.menuSection}>
          {section.items.map((item, index) => (
            <TouchableOpacity
              key={index}
              style={styles.menuItem}
              onPress={item.onPress}
            >
              <View style={styles.menuContent}>
                <item.icon
                  size={20}
                  color={
                    item.isDestructive
                      ? FlickOColors.error
                      : FlickOColors.text.primary
                  }
                />
                <Text
                  style={[
                    styles.menuText,
                    item.isDestructive && styles.destructiveText,
                  ]}
                >
                  {item.title}
                </Text>
              </View>
              <ChevronRight size={20} color={FlickOColors.gray.medium} />
            </TouchableOpacity>
          ))}
        </View>
      ))}

      <View style={styles.versionContainer}>
        <Info size={16} color={FlickOColors.text.secondary} />
        <Text style={styles.versionText}>Version {config.app.version}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: FlickOColors.gray.lighter,
  },
  restaurantSection: {
    backgroundColor: FlickOColors.white,
    padding: getResponsiveSize(16),
    marginBottom: getResponsiveSize(16),
  },
  menuSection: {
    backgroundColor: FlickOColors.white,
  },
  restaurantName: {
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
    color: FlickOColors.text.primary,
  },
  emailText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    marginTop: getResponsiveSize(4),
  },
  menuItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(16),
    borderBottomWidth: 1,
    borderBottomColor: FlickOColors.gray.light,
    justifyContent: "space-between",
  },
  menuContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(12),
  },
  menuText: {
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.primary,
  },
  destructiveText: {
    color: FlickOColors.error,
  },
  versionContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: getResponsiveSize(16),
    gap: getResponsiveSize(8),
    marginTop: "auto",
  },
  versionText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
  },
});

export default GenericNavigationMenu;
